export const SERVER = process.env.REACT_APP_SERVER;
export const API_URL = `${SERVER}v1/`;
export const DOCUMENTS_URL = `${SERVER}/documents/`;
export const USERS_MODEL_XLS = `${SERVER}/rules/usermodel.xlsx`;